import { render } from "./admin-workspace-all.vue?vue&type=template&id=011f0c4f"
import script from "./admin-workspace-all.vue?vue&type=script&lang=js"
export * from "./admin-workspace-all.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-workspace-all.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "011f0c4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('011f0c4f', __exports__)) {
    api.reload('011f0c4f', __exports__)
  }
  
  module.hot.accept("./admin-workspace-all.vue?vue&type=template&id=011f0c4f", () => {
    api.rerender('011f0c4f', render)
  })

}


export default __exports__